import { useEffect } from 'react';

import { useIsPhone, useTitle } from '@hooks';
import { PageTitle } from 'constants/pageTitle';
import { Box, Paper } from '@mui/material';
import { logEvent } from '@services';
import { TeamsListing } from '@components';
import { transparentPanelSx } from 'theme/surfaces';

export const Teams = () => {
  const setPageTitle = useTitle();
  const isPhone = useIsPhone();

  useEffect(() => {
    setPageTitle(PageTitle.TEAMS_PAGE);
    logEvent('teams_page_visit');
  }, [setPageTitle]);

  return (
    <Box
      sx={{
        maxWidth: 1400,
        margin: 'auto',
      }}
    >
      <Paper
        elevation={2}
        sx={{
          margin: 2,
          ...(isPhone && { margin: 1, ...transparentPanelSx }),
        }}
      >
        <TeamsListing />
      </Paper>
    </Box>
  );
};
